export default __webpack_public_path__ + "static/media/erythree_carte_6-min.04e3b8d8.png";